/**
 * @type {TwilioConnectionStatuses}
 * @description An enumeration of the possible Twilio connection statuses
 */
export const TwilioConnectionStatuses = {
  // Custom statuses
  UNINITIALIZED: 'uninitialized',
  INITIALIZING: 'initializing',

  // Twilio Client statuses
  CONNECTED: 'connected',
  DISCONNECTING: 'disconnecting',
  DISCONNECTED: 'disconnected',
  DENIED: 'denied'
};
